<template>
    <header class="d-flex align-items-center pb-3 mb-5 border-bottom">
        <router-link class="d-flex align-items-center text-dark text-decoration-none" to="/">
            <i class="bi bi-file-spreadsheet fs-3 me-1"></i>
            <span class="fs-4">Degiro Portfolio Manager</span>
        </router-link>
    </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>

</style>
